var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide',{staticClass:"v-announce-step"},[_c('v-text',{staticClass:"v-announce-step__title",attrs:{"heading":"","size":"medium"}},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"v-announce-step__image",attrs:{"src":_vm.imgSrc,"alt":_vm.alt}}),_c('div',{staticClass:"v-announce-step__description"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }